import { getUserInfo } from '@/utils/authUtils'

const COMPANY_STORAGE_KEY = 'currentCompanyId'
// H5 暂不支持“全部公司”模式，只允许具体公司
export const BOERSI_COMPANY_ID = 1
export const BOSI_COMPANY_ID = 2
const SUPPORTED_COMPANY_IDS = [BOERSI_COMPANY_ID, BOSI_COMPANY_ID]

function parseCompanyId(value) {
  const companyId = Number(value)
  return SUPPORTED_COMPANY_IDS.includes(companyId) ? companyId : null
}

function getCompanyIdsFromUserInfo(userInfo) {
  const companyIds = Array.isArray(userInfo?.companyIds) ? userInfo.companyIds : []
  return companyIds.map(parseCompanyId).filter(Boolean)
}

/**
 * 根据用户权限初始化当前公司。
 * H5 不提供“全部公司”，多公司用户默认第一家，用户可在页面上切换。
 */
export function initializeCompanyContext(userInfo) {
  const companyIds = getCompanyIdsFromUserInfo(userInfo)
  const storedCompanyId = parseCompanyId(localStorage.getItem(COMPANY_STORAGE_KEY))

  let currentCompanyId = storedCompanyId
  if (!currentCompanyId || (companyIds.length > 0 && !companyIds.includes(currentCompanyId))) {
    currentCompanyId = companyIds[0] || BOERSI_COMPANY_ID
  }

  localStorage.setItem(COMPANY_STORAGE_KEY, String(currentCompanyId))
  return currentCompanyId
}

export function getCurrentCompanyId() {
  const storedCompanyId = parseCompanyId(localStorage.getItem(COMPANY_STORAGE_KEY))
  if (storedCompanyId) {
    return storedCompanyId
  }

  // 支持用户直接打开 H5 深链：优先从已缓存用户信息恢复公司上下文
  let userInfo = null
  try {
    userInfo = getUserInfo()
  } catch (e) {
    userInfo = null
  }
  return initializeCompanyContext(userInfo)
}

export function setCurrentCompanyId(companyId) {
  const parsedCompanyId = parseCompanyId(companyId)
  if (!parsedCompanyId) {
    throw new Error('不支持的公司')
  }
  localStorage.setItem(COMPANY_STORAGE_KEY, String(parsedCompanyId))
}
